const base = '/health-tracker/diagnostic-log'

const routes = {
    risks: base.concat('/associated-risks')
}

export { routes }